// extracted by mini-css-extract-plugin
export default {"container":"UploadingLoader_container__uDra3","wrapper":"UploadingLoader_wrapper__Jm2+x","description":"UploadingLoader_description__zKnv-","loader":"UploadingLoader_loader__NmlJk"};